<template>
  <div style="background-color:white;height: 100%;width: 100%;">
    <el-row :gutter="50">
      <el-col :span="12">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item style="width:300px">
            <el-select v-model="deviceInfo.id" @change="selectNode" style="width:300px" placeholder="请选择流程">
              <el-option v-for="item in options" :key="item.id" :label="item.workflowName" :value="item.id">
              </el-option> </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="openNode">新增节点</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="danger" @click="delNode">删除节点</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="preservation">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item style="width:300px">
            <el-select style="width:300px" v-model="questionForm1.id" @change="selectActivity" placeholder="请选择流程">
              <el-option v-for="item in options1" :key="item.nodeId" :label="item.nodeName" :value="item.nodeId">
              </el-option> </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="openConmpany">单位授权</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="openUser">用户授权</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="12">
        <div style="height:530px;border:1px solid #000">
          <el-table :data="tableData" height="100%" style="width: 100%" ref="multipleTable"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }"
            :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
            <el-table-column type="selection"> </el-table-column>
            <el-table-column type="index" label="序号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="nodeName" label="节点名称">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" :disabled="scope.$index === 0" @click="moveUp(scope.$index, scope.row)"><i
                    class="el-icon-arrow-up"></i></el-button>
                <el-button size="mini" :disabled="scope.$index === (tableData.length - 1)"
                  @click="moveDown(scope.$index, scope.row)"><i class="el-icon-arrow-down"></i></el-button>
                <el-button size="small" type="primary" @click="updNode(scope.row)">修改节点</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="height:530px;border:1px solid #000">
          <el-table :data="activityData" height="100%" style="width: 100%"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="userName" label="授权用户" align="center">
            </el-table-column>
            <el-table-column prop="companyName" label="授权单位" align="center">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="deleteActivity(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="id" v-if="false">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!----------------------------------------------------------修改节点弹框--------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogVisible3"  title="修改节点" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">

      <el-form :model="inform" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:10%;">
        <el-form-item label="节点名称">
          <el-input v-model="inform.nodeName" :readonly="true" />
        </el-form-item>
        <el-form-item label="新名称">
          <el-input placeholder="请输入节点名称" v-model="inform.newName" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="updateNodeN">确 定</el-button>
      </span>
    </el-dialog>
    <!----------------------------------------------------------添加节点弹框--------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogVisible" title="增加节点" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">

      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:10%;">
        <el-form-item label="新增节点">
          <el-input placeholder="请输入节点名称" v-model="questionForm.nodeName" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="addNode">确 定</el-button>
      </span>
    </el-dialog>
    <!-----------------------------------------------------------单位选择弹框--------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-table ref="company" id="company" :data="companyData" height="450" style="width: 100%">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="companyName" label="授权单位">
        </el-table-column>
        <el-table-column prop="companyCode" v-if="false">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="SubmitCompanyNodeActivity">确 定</el-button>
      </span>
    </el-dialog>
    <!-----------------------------------------------------------用户选择弹框--------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogVisible2" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :inline="true" :model="userInfo" class="demo-form-inline">
        <el-form-item label="状态">
          <el-select v-model="userInfo.companyCode" filterable clearable placeholder="请选择状态" style="width:120px">
            <el-option v-for="item in companyData" :key="item.companyCode" :label="item.companyName"
              :value="item.companyCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模糊搜索">
          <el-input v-model="userInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="findUser">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="user" id="user" :data="userData" stripe border height="300" style="width: 100%">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="userId" label="用户账号">
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名">
        </el-table-column>
        <el-table-column prop="companyName" label="所属单位">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="SubmitNodeActivity">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { findAllWorkflow, findByIdNode, updateNode, selectAllCompany, findByNodeActivity, addNodeActivity, findAllUser, deleteNodeActivity, updateNodeName } from "../../api/api";
export default {
  name: "ProcessAuthorization",
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      options: [],
      options1: [],
      multipleTable: [],
      deviceInfo: {},
      tableData: [],
      questionForm: {},
      activityData: [],
      questionForm1: {},
      form: {},
      inform: {},
      company: [],
      companyData: [],
      userData: [],
      userInfo: [],
      user: [],
      nodeLocation: '',
    };
  },
  methods: {
    deleteActivity(row) {
      this.$confirm('确定删除此单位/用户的审批权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNodeActivity(row.id).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            var par = {
              nodeId: this.questionForm1.id,
              workflowId: this.form.id
            }
            this.findActivity(par);
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    updNode(row) {
      this.inform = {};
      this.dialogVisible3 = true;
      this.inform = row;
    },
    updateNodeN() {
      var map = {
        id: this.inform.id,
        nodeName: this.inform.newName
      }
      updateNodeName(map).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.dialogVisible3 = false;
          findByIdNode(this.form.id).then(datas => {
            let { status, data } = datas; 
            if (status == 200) {
              this.tableData = data
              var a = []
              for (var s = 0; s < data.length; s++) {
                a.push(data[s])
              }
              this.options1 = a
              this.activityData = [];
            }
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //构建添加授权用户信息
    SubmitNodeActivity() {
      let current = this.$refs.user.selection;
      var list = [];
      for (var i = 0; i < current.length; i++) {
        list.push({
          workflowId: this.form.id,
          warrantId: current[i].userId,
          nodeId: this.questionForm1.id
        })
      }
      this.insterNodeActivity(list);
      this.dialogVisible2 = false;
    },
    //构造添加授权单位数据
    SubmitCompanyNodeActivity() {
      let currentSelect = this.$refs.company.selection;
      var list = [];
      for (var i = 0; i < currentSelect.length; i++) {
        list.push({
          workflowId: this.form.id,
          warrantId: currentSelect[i].companyCode,
          nodeId: this.questionForm1.id
        })
      }
      this.insterNodeActivity(list);
      this.dialogVisible1 = false;
      this.findActivity(this.questionForm1.id)
    },
    //插入授权信息
    insterNodeActivity(row) {
      addNodeActivity(row).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          var out = {
            workflowId: this.form.id,
            nodeId: this.questionForm1.id
          };
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.findActivity(out)
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    // 根据节点id查找授权
    findActivity(row) {
      findByNodeActivity(row).then(datas => {
        let { status, message, data } = datas;
       if (status == 200) {
          this.activityData = data
        } 
      });
    },
    //打开单位授权弹框
    openConmpany() {
      if (this.questionForm1.id != null) {
        this.dialogVisible1 = true
        this.$refs.company.clearSelection()
      } else {
        this.$message({
          message: "请选择授权节点",
          type: "error"
        });
      }
    },
    //打开用户弹窗
    openUser() {
      if (this.questionForm1.id != null &&this.questionForm1.id!='') {
        this.dialogVisible2 = true
        this.$refs.user.clearSelection()
        this.userInfo = {}
        this.findUser()
      } else {
        this.$message({
          message: "请选择授权节点",
          type: "error"
        });
      }
    },
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    //查找节点授权
    selectActivity(row) {
      let sout = {
        workflowId: this.form.id,
        nodeId: row
      };
      this.findActivity(sout)
    },
    //保存节点信息
    preservation() {
      var a = this.tableData;
      for (var i = 0; i < a.length; i++) {
        a[i].location = a[i].index + 1
        a[i].workflowId = this.form.id
      }
      a.push({
        location: '0',
        nodeName: "订单创建",
        workflowId: this.form.id
      })
      updateNode(a).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.findIdNode(this.form.id)
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //查找节点
    selectNode(row) {
      this.form.id = row;
      this.questionForm1.id = '';
      findByIdNode(row).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.tableData = data
          var a = []
          for (var s = 0; s < data.length; s++) {
            a.push(data[s])
          }
          this.options1 = a
          this.activityData = [];
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //根据id查找节点信息
    findIdNode(row) {
      findByIdNode(row).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.tableData = data
          var a = []
          for (var s = 0; s < data.length; s++) {
            a.push(data[s])
          }
          this.options1 = a
          this.$message({
            message: "保存成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //移除节点
    delNode() {
      let arr = this.$refs.multipleTable.selection;
      for (var i = 0; i < arr.length; i++) {
        this.tableData.splice(this.tableData.indexOf(arr[i]), 1);
      }
    },
    //打开弹窗
    openNode() {
      this.questionForm = {};
      this.dialogVisible = true;
    },
    //增加节点信息
    addNode() {
      this.questionForm.workflowId = this.form.id
      this.tableData.push(this.questionForm)
      this.dialogVisible = false
    },
    //选择复选框数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //上移
    moveUp(index, row) {
      var that = this;
      if (index > 0) {
        let upDate = that.tableData[index - 1];
        that.tableData.splice(index - 1, 1);
        that.tableData.splice(index, 0, upDate);
      } else {
        alert('已经是第一条，不可上移');
      }
    },
    //下移
    moveDown(index, row) {
      var that = this;
      if ((index + 1) === that.tableData.length) {
        alert('已经是最后一条，不可下移');
      } else {
        // 保存下一条数据
        let downDate = that.tableData[index + 1];
        // 删除下一条数据
        that.tableData.splice(index + 1, 1);
        // 增添被删除的那一条数据
        that.tableData.splice(index, 0, downDate);
      }
    },
    findAll() {
      findAllWorkflow().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = data
        }
      });
    },
    findUser() {
      findAllUser(this.userInfo).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.userData = data;
        }
      });
    },
    selectCompany() {
      selectAllCompany().then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.companyData = data;
        } 
      });
    },
  },
  created() {
    this.findAll();
    this.selectCompany();
    this.findUser()
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/SystemSettings/ProcessAuthorization.vue